export const Props = () => ({
  //Аватар пользователя
  avatar: { type: String },

  //Имя пользователя
  name: { type: String },

  //Никнейм пользователя
  username: { type: String },

  //Описание пользователя
  description: { type: String },

  //Кол-во подписчиков
  followers: { type: [String, Number] },

  //Параметр x score
  xScore: { type: [String, Number] },

  //Параметр twitter score
  twitterScore: { type: [String, Number] },
})
